<template>
  <div id="topnav">
    <div class="logoNav">
      <div>
        <img src="../assets/img/u3109.png" alt="logo">
      </div>
      <div>智慧消防监测预警管理系统</div>
    </div>
    <div class="Navigation">
      <div class="listNavigation">
        <el-menu
          :default-active="activeIndex"
          mode="horizontal"
          @select="handleSelect"
          background-color="#254580"
          text-color="#fff"
          active-text-color="#198cff"
          router
          v-for="(todo,index) in rote"
          :key="index"
        >
          <el-menu-item :index="todo.roteUrl" :route="todo.roteUrl" v-if="todo.roteSon.length == 0">
            <a>{{todo.roteTxt}}</a>
          </el-menu-item>
          <el-submenu :index="todo.roteUrl" v-else>
            <template slot="title">
              <a>{{todo.roteTxt}}</a>
            </template>
            <el-menu-item v-for="(item,index2) in todo.roteSon" :key="index2" :index="item.roteUrl">
              <a>{{item.roteTxt}}</a>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
      <div class="userNavigation">
        <div style="width:100px;" v-if="userType != 0 && userType != 4 && userType != 5">
        <el-badge class="isDot" style="margin-right: 20px;" slot="reference" @click.native="Bigscreen">大屏</el-badge>
        <el-badge :is-dot="isDot" class="isDot" style="margin-right: 20px;" slot="reference" @mouseover.native="enter()" @mouseout.native="leave()" @click.native="msgDrop">消息</el-badge>
        </div>
        <div style="width:50px;" v-else>
        <el-badge class="isDot" style="margin-right: 20px;" slot="reference" @click.native="Bigscreen">大屏</el-badge>
        </div>
        <div @click="editUserInfo" v-if="headImgId">
          <img :src="headImgId" alt="头像">
        </div>
        <div @click="editUserInfo" v-else>
          <img v-if="imgUrl" :src="imgUrl" alt="头像">
          <img v-else src="../assets/img/topUser.png" alt="头像">
        </div>
        <div>{{userName}}</div>
        <div @click="logout">退出</div>
      </div>
    </div>
    <div v-if="userType != 0 && userType != 4&& userType != 5" style="padding:10px;" class="popoverContent" @mouseover="enterPopover()" @mouseout="leavePopover()" v-show="showPopoverContent">
      <div class="popoverContent__arrow">
        <em></em>
      </div>
      <div class="content">
        <div class="povperMsg" v-for="(item,index) in msgAlarmList" :key="index">
          <div class="left">
            <div v-if="item.detailAddress" :class="item.infoWidth>=410?'msg':'msg1' ">位于【{{item.detailAddress}}】的【 <span style="color:#7d0022">{{item.monitoringName}}</span>】发生
            <span v-if="item.monitoringType==5">
                <span v-if="item.content == 1 || item.content == 111">烟雾告警</span>
                <span v-else-if="item.content == 986">高温告警</span>
                <span v-else-if="item.content == 963">防拆告警</span>!
            </span>
            <span v-else>{{item.type==6?'预警':'告警'}}!</span>
            </div>
            <div v-else :class="item.infoWidth>=410?'msg':'msg1' ">您收到一条新公告!【{{item.title}}】</div>
            <div class="time">{{item.createDate | time}}</div>
          </div>
          <div class="right">
            <div class="know">
              <el-button @click="iKnow(item.id)">我知道了</el-button>
            </div>
            <div class="check">
              <el-button type="primary" @click="detail(item.monitoringId,item.id)">立刻查看</el-button>
            </div>
          </div>
        </div>
      </div>
      <audio v-if="isMsg" autoplay="autoplay" loop="loop">
        <source src="../../static/voice/dududu.mp3" type="audio/ogg">
      </audio>
    </div>
  </div>
</template>
<script>
import { ajaxFuncJson,SocketUrl,ajaxFuncJsonLogin } from "@/api/ajax";
import { uploadIp } from "@/api/ajax";
import { pushHistory } from "@/utils"; // 引入工具类
export default {
  props: ["headImgId"],
  data() {
    return {
      userType:sessionStorage.getItem("userType"),
      isDot: false,
      activeIndex: "",
      userName: localStorage.getItem("userName"),
      imgUrl: "",
      rote: [],
      socketMonitorMsgAlarm: null, // 告警通知
      timeOut: null,
      msgAlarmList: JSON.parse(sessionStorage.getItem('msgAlarmList')) != null ? JSON.parse(sessionStorage.getItem('msgAlarmList')) : [],
      socketNoticClose :1,//我关闭的
      lockReconnect: false,//是否真正建立连接
      timeoutnum: null,//断开 重连倒计时
      timeoutnumSucc: null,//断开 重连倒计时
      timeoutnumSucc1: null,//断开 重连倒计时
      arrayObject :[],//用于判断集团时候的数据
    };
  },
  filters: {
    time(val) {
      if ((new Date()).getTime() - val < 60 * 1000 ) {
        return val = '刚刚'
      } else if ((new Date()).getTime() - val < 60 * 60 * 1000) {
        return val =  Math.ceil(((new Date()).getTime() - val) / 1000 / 60) + '分钟前'
      } else if ((new Date()).getTime() - val < 24 * 60 * 60 * 1000) {
        return val =  Math.ceil(((new Date()).getTime() - val) / 1000 / 60 / 60)  + '小时前'
      } else {
        var time = new Date(val);
        var y = time.getFullYear();
        var m = time.getMonth()+1;
        var d = time.getDate();
        return val = y + '-' + m + '-' + d;
      }
    }
  },
  computed: {
    isMsg: {
     set(value) {
        this.$store.state.isMsg = value;
     },
     get() {
        return this.$store.state.isMsg;
     }
    },
    showPopoverContent: {
      set(value) {
        this.$store.state.showPopoverContent = value;
      },
      get() {
        return this.$store.state.showPopoverContent;
      }
    },
      form() {
       return this.$store.state.editBulitData
    }
  },
  watch: {
     form() {
       let _this = this;
      //  _this.activeIndex = '/content/constructionManagement';
     },
  },
  created() {
    let _this = this
    var imgIp = uploadIp();
    if(localStorage.getItem('avatar')&&localStorage.getItem('avatar')!='null'&&localStorage.getItem('avatar')!='undefined'){
      _this.imgUrl =
        imgIp + "/file/filePreview/" + localStorage.getItem("avatar");
    }else {
      _this.imgUrl ='';
    }
    if(sessionStorage.getItem('isDot')=='true'){
      this.isDot=true;
    }else {
      this.isDot=false;
    }
    _this.activeIndex = _this.$route.path;
    if(_this.$route.path==='/content/searchForm'){
      if(_this.$route.query.searchUrl==='2-1'){
        _this.activeIndex='/content/searchForm?2-1';
      }else if(_this.$route.query.searchUrl==='3-1'){
        _this.activeIndex='/content/searchForm?3-1';
      }else {
        _this.activeIndex='/content/searchForm';
      }
    }
    switch( _this.activeIndex) {
      case '/content/MonitoringSupervise': //监控中心监管端
          _this.activeIndex = '/content/MonitoringSupervise';
          sessionStorage.setItem('router','MonitoringSupervise');
          sessionStorage.setItem('showcus',1);
          this.getLeftBuildingMap('0');
        break;
     case '/content/monitorDetails': //监控中心
          _this.activeIndex = '/content/Monitoring';
          sessionStorage.setItem('router','MonitoringSupervise');
          sessionStorage.setItem('showcus',1);
           this.getLeftBuildingMap('0');
        break;
     case '/content/deleteSuccess': //报警管理
        _this.activeIndex = '/content/warningManger';
        break;
     case '/content/editForm':
        _this.activeIndex = '/content/warningManger';
        break;
     case '/content/examineSuccess':
        _this.activeIndex = '/content/warningManger';
        break;
     case '/content/exitSuccess':
        _this.activeIndex = '/content/warningManger';
        break;
     case '/content/indexExamine': //报警审核
        _this.activeIndex = '/content/indexExamine';
        break;
     case '/content/saveSuccess':
        _this.activeIndex = '/content/warningManger';
        break;
      case '/content/searchForm': //公共
        _this.activeIndex = '/content/warningManger';
        break;
      case '/content/searchForm?2-1': //公共
        _this.activeIndex = '/content/indexExamine';
        break;
      case '/content/searchForm?3-1': //公共
        _this.activeIndex = '/content/searchWarnIndex';
        break;
      case '/content/searchWarnDetail'://综合查询
        _this.activeIndex = '/content/searchWarnIndex';
        break;      
      case '/content/searchWarnIndex': //综合查询
        _this.activeIndex = '/content/searchWarnIndex';
        break;      
      case '/content/submitSuccess':
        _this.activeIndex = '/content/warningManger';
        break;      
      case '/content/warnDetail': //报警处理
        _this.activeIndex = '/content/warningManger';
        break;      
      case '/content/warnExamine': //报警审核
        _this.activeIndex = '/content/indexExamine';
        break;      
      case '/content/withDrawSuccess':
        _this.activeIndex = '/content/warningManger';
        break;      
      case '/content/addMonitor': //基础数据
        _this.activeIndex = '/content/BasicData';
        break;      
      case '/content/deleteSuccessfully':
        _this.activeIndex = '/content/BasicData';
        break;      
      case '/content/saveSuccessfully':
        _this.activeIndex = '/content/BasicData';
        break;
      case '/content/saveSuccessfully1':
        _this.activeIndex = '/content/constructionManagement';
        break;      
      case '/content/editBuliting':
        _this.activeIndex = '/content/constructionManagement';
        break;      
    //   case '/searchUserInfo': //系统管理 (用户管理)
    //     _this.activeIndex = '/userManger';
    //     break;   
    //   case '/editUser': //系统管理 (用户管理)
    //     _this.activeIndex = '/userManger';
    //     break; 
     default:
    } 
    if(this.$route.path == '/content/Monitoring'){
      this.ajaxShowRed(0); //小红点
    }else if(this.$route.path == '/content/monitorDetails'){
      this.ajaxShowRed(0); //小红点
    }else if(this.$route.path == '/content/warningManger'){
      this.ajaxShowRed(1); //小红点
    }else if(this.$route.path == '/content/indexExamine'){
      this.ajaxShowRed(2); //小红点
    }else if(this.$route.path == '/content/searchWarnIndex'){
      this.ajaxShowRed(0); //小红点
    }
    // 权限
    this.rote = [];
      if(this.isAuth('common:interface')){ //监控中心
      if(this.userType != 0){
          this.rote.push({
            roteUrl: "/content/MonitoringSupervise",
            roteTxt: "监控中心",
            roteSon: []
          })
        }else{
            this.rote.push({
            roteUrl: "/content/MonitoringSupervise",
            roteTxt: "监控中心",
            roteSon: []
          })
        }
      }else{
          this.rote.push({
            roteUrl: "",
            roteTxt: "",
            roteSon: []
          })
      }
      if(this.isAuth('#AlarmManage')){ //报警管理
              this.rote.push({
                roteTxt: "报警管理",
                roteUrl: "",
                roteSon: []
              })
  
      }
      if(this.isAuth('#AlarmHand')){ //报警处理
          this.rote.forEach((a,b) => {
            if(a.roteTxt == '报警管理'){
                a.roteSon.push({
                    roteUrl: "/content/warningManger",
                    roteTxt: "报警处理"
                  }
                )
            }
          });
      }
      if(this.isAuth('#WarningAudit')){ //报警审核
          this.rote.forEach((a,b) => {
            if(a.roteTxt == '报警管理'){
                a.roteSon.push({
                roteUrl: "/content/indexExamine",
                roteTxt: "报警审核"
              })
            }
          });
      }
      if(this.isAuth('#ComQuery')){ //综合查询
          this.rote.forEach((a,b) => {
            if(a.roteTxt == '报警管理'){
                a.roteSon.push({
                roteUrl: "/content/searchWarnIndex",
                roteTxt: "综合查询"
              })
            }
          });
      }
      if(this.isAuth('#Analysis')){ //统计分析
          this.rote.push({
            roteTxt: "统计分析",
            roteUrl: "/content/analysis",
            roteSon: []
          })
      }
      if(this.isAuth('#Analysis')){ //报警统计
          this.rote.forEach((a,b) => {
            if(a.roteTxt == '统计分析'){
                a.roteSon.push({
                    roteUrl: "/content/analysis",
                    roteTxt: "报警统计"
                  }
                )
            }
          });
      }
      if(this.isAuth('#Analysis') && this.userType == 1 || this.userType == 2){ //分析报告
          this.rote.forEach((a,b) => {
            if(a.roteTxt == '统计分析'){
                a.roteSon.push({
                    roteUrl: "/content/report",
                    roteTxt: "分析报告"
                  }
                )
            }
          });
      }
      if(this.isAuth('#Analysis') && this.userType == 1 || this.userType == 2){ //分析报告
          this.rote.forEach((a,b) => {
            if(a.roteTxt == '统计分析'){
                a.roteSon.push({
                    roteUrl: "/content/deviceList",
                    roteTxt: "设备列表"
                  }
                )
            }
          });
      }
      if(this.isAuth('#notice') && sessionStorage.getItem('userType') == '0'){   //通知公告
        this.rote.push({
          roteTxt:'通知公告',
          roteUrl:'/notificate',
          roteSon:[],
        })
      }
      if(this.isAuth('#BasicData')){ //基础数据
            this.rote.push({
              roteTxt: "基础数据",
              roteUrl: "",
              roteSon: []
            })
      }
      if(this.isAuth('#MonitorManage')){ //监测点管理
              this.rote.forEach((a,b) => {
              if(a.roteTxt == '基础数据'){
                  a.roteSon.push({
                roteUrl: "/content/BasicData",
                roteTxt: "监测点管理"
                })
              }
            });
      }
      if(this.isAuth('#basicData')){ //建筑管理
              this.rote.forEach((a,b) => {
              if(a.roteTxt == '基础数据'){
                  a.roteSon.push({
               roteUrl: "/content/constructionManagement",
                roteTxt: "建筑管理"
                })
              }
            });
      }      
     this.rote.forEach((a,b) => {
        if(a.roteTxt == '基础数据'){
            a.roteSon.push({
          roteUrl: "/addViewX",
          roteTxt: "3D配置"
          })
        }
      });
  },
  mounted() {
    pushHistory();
      this.getMsgAlarm();
    // 监听历史记录点, 添加返回事件监听
    window.onpopstate = () => {
      this.activeIndex = this.$route.path;
    };
    this.$nextTick(()=>{
      
      if(this.msgAlarmList.length>0){
        this.msgAlarmList.forEach((item,index)=>{
          //  item.infoWidth =  this.textSize("13px","Arial",'位于【'+item.detailAddress+'】的【'+item.monitoringName+'】发生告警!').width;
            if(item.detailAddress){ //五期公告推送
              item.infoWidth =  this.textSize("13px","Arial",'位于【'+item.detailAddress+'】的【'+item.monitoringName+'】发生告警!').width;
            }else{
              item.infoWidth =  this.textSize("13px","Arial",'您收到一条新公告!【'+item.title+'】').width;
            }
        })
      }
      
    })
  },
  methods: {
    textSize(fontSize,fontFamily,text){
      var span = document.createElement("span");
      var result = {};
      result.width = span.offsetWidth;
      result.height = span.offsetHeight;
      span.style.visibility = "hidden";
      span.style.fontSize = fontSize;
      span.style.fontFamily = fontFamily;
      span.style.display = "inline-block";
      document.body.appendChild(span);
      if(typeof span.textContent != "undefined"){
        span.textContent = text;
      }else{
        span.innerText = text;
      }
      result.width = parseFloat(window.getComputedStyle(span).width) - result.width;
      result.height = parseFloat(window.getComputedStyle(span).height) - result.height;
      return result;
    },
    enter() {
      if (this.msgAlarmList.length > 0) {
        this.showPopoverContent = true;
      } else {
        this.showPopoverContent = false;
      }
    },
    leave() {
      this.showPopoverContent = false;
    },
    enterPopover() {
      this.showPopoverContent = true;
    },
    leavePopover() {
      this.showPopoverContent = false;
    },
    msgDrop() {
      this.isDot=false;
      sessionStorage.setItem('isDot',this.isDot);
      this.msgAlarmList=[];
      this.isMsg=false;
      sessionStorage.setItem('msgAlarmList','[]');
      this.showPopoverContent = false;
      sessionStorage.setItem('router','userInfo');
      sessionStorage.setItem('showListPage',false)
      this.$router.push({path:'/userInfo',query:{showListPage:false,pageType:2}})
    },
    detail(id,Id) {
      if(id){
         this.iKnow(id);
        sessionStorage.setItem("saveId",id);
        this.isMsg=false;
        this.activeIndex =  '/content/Monitoring';
        this.$router.push({path:'/content/monitorDetails',query:{ t:Date.now()}});
        if (id == this.msgAlarmList[0].monitoringId) {
          this.showPopoverContent = false;
        }
      }else{
        this.iKnow(Id);
        this.isMsg=false;
        this.$router.push({path:'/userInfo',query:{pageType:3}});
      }
    },
    iKnow(id) {
      let params = {
        noticeId: id
      };
      ajaxFuncJson("/alarmNoticeRecord/readNotice", params).then(res => {
        if (res.data.status == 200) {
          this.showPopoverContent = true;
          this.isMsg=false;
          let indexNum='';
          this.msgAlarmList.forEach((item,index)=>{
            if(item.id==id){
              indexNum=index;
            }
          });
          this.msgAlarmList.splice(indexNum, 1);
          sessionStorage.setItem('msgAlarmList',JSON.stringify(this.msgAlarmList));
          if (this.msgAlarmList.length == 0) {
            this.isDot=false;
            sessionStorage.setItem('isDot',this.isDot);
            this.showPopoverContent = false;
          }
        }else {
          this.$message({
            message:res.data.msg,
            type:'error',
          })
        }
      })
    },
    format(e) {
      //时间戳是整数，否则要parseInt转换
      var time = new Date(e);
      var y = time.getFullYear();
      var m = time.getMonth()+1;
      var d = time.getDate();
      return y + '-' + m + '-' + d;
    },
    getMsg() {
      let _this = this;
      if(_this.isAuth('common:interface')){
        ajaxFuncJson("/alarmNoticeRecord/isUnreadNoticeExist").then(res => {
          if (res.data.status == 200) {
            if (res.data.data == true) {
              _this.isDot = true;
              sessionStorage.setItem('isDot',_this.isDot);    //设置消息显示红点
            } else {
              _this.isDot = false;
              sessionStorage.setItem('isDot',_this.isDot);
            }
          } else {
            _this.$message.error(res.data.msg);
          }
        });
      }
    },
    ajaxShowRed(pageType){
      console.log('我的pageType'+pageType)
        ajaxFuncJson('/basicData/getShowRedBuildIdList',{pageType:pageType,customerId:sessionStorage.getItem('customerId')}).then(res=>{
          if(res.data.status == 200){
              this.redArray = res.data.data; //存储圆点
              sessionStorage.setItem('reddata',JSON.stringify(this.redArray))
              this.$store.state.reddata = this.redArray; //小红点变化
          }
        })
    },
     // 心跳
    timeoutnumSuccF(){
        var that = this;
        that.timeoutnumSucc && clearTimeout(that.timeoutnumSucc);
        that.timeoutnumSucc1 && clearTimeout(that.timeoutnumSucc1);
        that.timeoutnumSucc = setTimeout(function () {
        
          if (that.socketMonitorMsgAlarm.readyState===1) {
            that.socketMonitorMsgAlarm.send("monitorReconnection");
          }else{
              //do something
          }
          that.timeoutnumSucc1 = setTimeout(function () {
            that.socketMonitorMsgAlarm.close();
          },10000);
        },1200000);
    },
    getMsgAlarm() {
          let token = sessionStorage.getItem('token');
          let webSocketUrl = SocketUrl();
          let wsuri = webSocketUrl + "/common/notReadNotice?token=" + token;
          if(token){
            this.socketMonitorMsgAlarm = new WebSocket(wsuri);
            this.socketMonitorMsgAlarm.onopen = this.Monitoronopen;
            this.socketMonitorMsgAlarm.onerror = this.Monitoronerror;
            this.socketMonitorMsgAlarm.onmessage = this.Monitoronmessage;
            this.socketMonitorMsgAlarm.onclose = this.Monitorclose;
          }
    },
    Monitoronopen() {
      console.log("顶部导航实时推送-连接成功");
      this.socketNoticClose = 1;//连接成功他就等于1
      this.timeoutnumSuccF()
    },
    Monitoronerror(e) {
      console.log("顶部导航实时推送-连接错误",e);
    },
    Monitoronmessage(e) {
      if(e.data =="connectSuccess"){
        this.timeoutnumSuccF();
        return;
      }else{
        if(e.data == "update_red_building"){
               let _this = this
              if(this.$route.path == '/content/Monitoring'){
                this.ajaxShowRed(0); //小红点
              }else if(this.$route.path == '/content/warningManger'){
                this.ajaxShowRed(1); //小红点
              }else if(this.$route.path == '/content/indexExamine'){
                this.ajaxShowRed(2); //小红点
              }else if(this.$route.path == '/content/searchWarnIndex'){
                this.ajaxShowRed(0); //小红点
              }
             if((this.$route.path).includes('/content/warnDetail')){
                this.ajaxShowRed(1); //小红点
              }
             if((this.$route.path).includes('/content/warnExamine')){
                this.ajaxShowRed(2); //小红点
              }
                           if((this.$route.path).includes('/content/searchWarnDetail')){
                this.ajaxShowRed(0); //小红点
              }
               if((this.$route.path).includes('/content/submitSuccess')||(this.$route.path).includes('/content/deleteSuccess')||(this.$route.path).includes('/content/saveSuccess')||(this.$route.path).includes('/content/withDrawSuccess')){
                this.ajaxShowRed(1); //小红点
              }
               if((this.$route.path).includes('/content/examineSuccess')||(this.$route.path).includes('/content/exitSuccess')){
                this.ajaxShowRed(2); //小红点
              }

        }else{
              let _this = this
              sessionStorage.setItem('msgAlarmList',e.data)
              if(this.$route.path == '/content/Monitoring'){
                this.ajaxShowRed(0); //小红点
              }else if(this.$route.path == '/content/warningManger'){
                this.ajaxShowRed(1); //小红点
              }else if(this.$route.path == '/content/indexExamine'){
                this.ajaxShowRed(2); //小红点
              }else if(this.$route.path == '/content/searchWarnIndex'){
                this.ajaxShowRed(0); //小红点
              }
              //数据接收
              const res = JSON.parse(e.data);
              if(res.length>0){
                res.forEach((item,index)=>{
                  if(item.statusType){ //五期公告推送
                    if(item.type == 6){
                      item.infoWidth =  this.textSize("13px","Arial",'位于【'+item.detailAddress+'】的【'+item.monitoringName+'】发生预警!').width;
                    }else{
                      item.infoWidth =  this.textSize("13px","Arial",'位于【'+item.detailAddress+'】的【'+item.monitoringName+'】发生告警!').width;
                    }
                  }else{
                    item.infoWidth =  this.textSize("13px","Arial",'您收到一条新公告!【'+item.title+'】').width;
                  }
                })
              }
              _this.msgAlarmList = res;
              if(_this.msgAlarmList[0].monitoringId){
                sessionStorage.setItem('monitoringId',_this.msgAlarmList[0].monitoringId)
              }else{
                sessionStorage.setItem('monitoringId','')
              }
              if (_this.msgAlarmList.length > 0) {
                _this.getMsg();
                if(sessionStorage.getItem('islock') == 'true'){
                  _this.isMsg = true;
                }
                _this.showPopoverContent = true;
                _this.$store.state.navTopMsg = 1;  // 1表示有消息推送
                _this.msgAlarmList.map( e => {
                  _this.$set(e,'time','');
                  _this.$set(e,'msg','');
                  e.createDate = new Date(e.createDate); //将日期时间转换成时间戳
                  if ((new Date()).getTime() - e.createDate < 60 * 1000 ) {
                    e.time = '刚刚'
                  } else if ((new Date()).getTime() - e.createDate < 60 * 60 * 1000) {
                    e.time =  Math.ceil(((new Date()).getTime() - e.createDate) / 1000 / 60) + '分钟前'
                  } else if ((new Date()).getTime() - e.createDate < 24 * 60 * 60 * 1000) {
                    e.time =  Math.ceil(((new Date()).getTime() - e.createDate) / 1000 / 60 / 60)  + '小时前'
                  } else {
                    e.time = _this.format(e.createDate)
                  }
                })
                clearTimeout(_this.timeOut);
                _this.timeOut = setTimeout(() => {
                  _this.isMsg = false;
                  _this.showPopoverContent = false;
                },60000)
              }
        }
      }
    },
    Monitorsend(agentData) { //数据发送
      //this.websock.send(agentData);
    },
    Monitorclose(e) { //关闭
      console.log("顶部导航实时推送-连接断开 (" + e.code + ")");
      if(e.code != 1000){
          if(this.socketNoticClose == 2)return;
          var that = this;
          if(that.lockReconnect) {
              return;
          };
          that.lockReconnect = true;
          //没连接上会一直重连，设置延迟避免请求过多
          that.timeoutnum && clearTimeout(that.timeoutnum);
          that.timeoutnum = setTimeout(function () {
              //新连接
              that.getMsgAlarm();//连接websocket  
              that.lockReconnect = false;
          },10000);
      }
    },
    handleSelect(key, keyPath) {
      sessionStorage.setItem('searName','');//通知公告清除历史数据
      sessionStorage.setItem('returnType',0) //区分是否保留筛选条件历史记录
      this.activeIndex = key;
      switch (key) {
        case "/content/Monitoring": //监控中心
          sessionStorage.setItem("router", "MonitoringSupervise"); // 判断顶部进入那个路由
          sessionStorage.setItem('differentiate',true); //判断是否可以取消选中
          sessionStorage.setItem("navAddShow", false);
          sessionStorage.setItem('menuS',sessionStorage.getItem("buildingId"))
          this.$store.state.menuS = sessionStorage.getItem("buildingId")
          sessionStorage.setItem('showcus','0')  // 客户是否可以点击1表示可以0不可以
          this.$store.state.navAddShow = false;
          this.$store.state.routerUrlName=key;
          sessionStorage.setItem('target','0')
          this.ajaxShowRed(0); //小红点
           this.getLeftBuildingMap('0');
          break;
        case "/content/MonitoringSupervise": //监控中心监管端
          sessionStorage.setItem('differentiate',true); //判断是否可以取消选中

          sessionStorage.setItem("router", "MonitoringSupervise"); // 判断顶部进入那个路由
          sessionStorage.setItem("navAddShow", false);
          this.$store.state.navAddShow = false;
          this.$store.state.listenerIsWarn=false;
          this.$store.state.routerUrl=false;
          this.$store.state.routerUrlName=key;
          this.$store.state.menuS = '';
          sessionStorage.setItem('showcus','1')  // 客户是否可以点击1表示可以0不可以
          sessionStorage.setItem('menuS','');
          sessionStorage.setItem('target','0')
          this.getLeftBuildingMap('0');
          break;
        case "/content/warningManger": //报警处理
          sessionStorage.setItem("navAddShow", false);
          sessionStorage.setItem('router','warningManger');
          this.$store.state.navAddShow = false;
          this.$store.state.routerUrlName=key;
          this.$store.state.menuS = sessionStorage.getItem("buildingId")
          sessionStorage.setItem('showcus','0')  // 客户是否可以点击1表示可以0不可以
          sessionStorage.setItem('target','0')
           this.ajaxShowRed(1); //小红点
           this.getLeftBuilding('0');
          break;
        case "/content/indexExamine": //报警审核
          sessionStorage.setItem('router','indexExamine');
          sessionStorage.setItem("navAddShow", false);
          this.$store.state.navAddShow = false;
          this.$store.state.routerUrlName=key;
          this.$store.state.menuS = sessionStorage.getItem("buildingId")
          sessionStorage.setItem('showcus','0')  // 客户是否可以点击1表示可以0不可以
          sessionStorage.setItem('target','0')
          this.ajaxShowRed(2); //小红点
          this.getLeftBuilding('0');
          break;
        case "/content/searchWarnIndex": //综合查询
          this.getLeftBuilding('0');
          sessionStorage.setItem("navAddShow", false);
          sessionStorage.setItem('router','searchWarnIndex');
          this.$store.state.navAddShow = false;
          this.$store.state.routerUrlName=key;
          this.$store.state.menuS = sessionStorage.getItem("buildingId")
          sessionStorage.setItem('showcus','0')  // 客户是否可以点击1表示可以0不可以
          sessionStorage.setItem('target','0')
          this.ajaxShowRed(0); //小红点
          break;
        case "/content/analysis": //统计分析
          sessionStorage.setItem("router", "analysis"); // 判断顶部进入那个路由
          sessionStorage.setItem("navAddShow", false);
          this.$store.state.navAddShow = false;
          this.$store.state.listenerIsWarn=false;
          this.$store.state.routerUrl=false;
          this.$store.state.routerUrlName=key;
          if(sessionStorage.getItem('leftData')){
            sessionStorage.setItem('menuS',JSON.parse(sessionStorage.getItem('leftData'))[0].id);// 默认缓存第一个客户id
            this.$store.state.menuS = JSON.parse(sessionStorage.getItem('leftData'))[0].id;
            sessionStorage.setItem('analyName', JSON.parse(sessionStorage.getItem('leftData'))[0].label); // 默认缓存第一个客户名
          }else{
            this.$store.state.menuS = '';
            sessionStorage.setItem('menuS','');
          }
          sessionStorage.setItem('analyBuildingId', ''); // 缓存建筑id-统计分析专用
          this.$store.state.analyBuildingId = sessionStorage.getItem('analyBuildingId');
          sessionStorage.setItem('showcus','1')  // 客户是否可以点击1表示可以0不可以
          sessionStorage.setItem('target','1')
           sessionStorage.setItem('differentiate',true); //判断是否可以取消选中
           this.getLeftBuildingMap('0');
          break;
          case "/content/report": //分析报告
          sessionStorage.setItem("router", "report"); // 判断顶部进入那个路由
          sessionStorage.setItem("navAddShow", false);
          this.$store.state.navAddShow = false;
          this.$store.state.listenerIsWarn=false;
          this.$store.state.routerUrl=false;
          this.$store.state.routerUrlName=key;
          if(sessionStorage.getItem('leftData')){
            sessionStorage.setItem('menuS',JSON.parse(sessionStorage.getItem('leftData'))[0].id);// 默认缓存第一个客户id
            this.$store.state.menuS = JSON.parse(sessionStorage.getItem('leftData'))[0].id;
            sessionStorage.setItem('analyName', JSON.parse(sessionStorage.getItem('leftData'))[0].label); // 默认缓存第一个客户名
          }else{
            this.$store.state.menuS = '';
            sessionStorage.setItem('menuS','');
          }
          sessionStorage.setItem('analyBuildingId', ''); // 缓存建筑id-统计分析专用
          this.$store.state.analyBuildingId = sessionStorage.getItem('analyBuildingId');

          sessionStorage.setItem('buildingId', ''); // 缓存建筑id-统计分析专用
          this.$store.state.buildingId = '';

          sessionStorage.setItem('showcus','1')  // 客户是否可以点击1表示可以0不可以
          sessionStorage.setItem('target','1')
           sessionStorage.setItem('differentiate',true); //判断是否可以取消选中
           this.getLeftBuildingMap('0');
          break;
          case "/content/deviceList": //设备列表
          sessionStorage.setItem("router", "deviceList"); // 判断顶部进入那个路由
          sessionStorage.setItem("navAddShow", false);
          this.$store.state.navAddShow = false;
          this.$store.state.listenerIsWarn=false;
          this.$store.state.routerUrl=false;
          this.$store.state.routerUrlName=key;
          if(sessionStorage.getItem('leftData')){
            sessionStorage.setItem('menuS',JSON.parse(sessionStorage.getItem('leftData'))[0].id);// 默认缓存第一个客户id
            this.$store.state.menuS = JSON.parse(sessionStorage.getItem('leftData'))[0].id;
            sessionStorage.setItem('analyName', JSON.parse(sessionStorage.getItem('leftData'))[0].label); // 默认缓存第一个客户名
          }else{
            this.$store.state.menuS = '';
            sessionStorage.setItem('menuS','');
          }
          sessionStorage.setItem('analyBuildingId', ''); // 缓存建筑id-统计分析专用
          this.$store.state.analyBuildingId = sessionStorage.getItem('analyBuildingId');

          sessionStorage.setItem('buildingId', ''); // 缓存建筑id-统计分析专用
          this.$store.state.buildingId = '';

          sessionStorage.setItem('showcus','1')  // 客户是否可以点击1表示可以0不可以
          sessionStorage.setItem('target','1')
           sessionStorage.setItem('differentiate',true); //判断是否可以取消选中
           this.getLeftBuildingMap('0');
          break;
          case "/content/superviseTagging": //校企标注
          sessionStorage.setItem("router", "superviseTagging"); // 判断顶部进入那个路由
          sessionStorage.setItem('differentiate',false); //判断是否可以取消选中
          sessionStorage.setItem("navAddShow", false);
          sessionStorage.setItem("btnShow", true);
          this.$store.state.navAddShow = false;
          this.$store.state.listenerIsWarn=false;
          this.$store.state.routerUrl=false;
          this.$store.state.routerUrlName=key;
          sessionStorage.setItem('showcus','0')  // 客户是否可以点击1表示可以0不可以
          sessionStorage.setItem('menuS2','');
          sessionStorage.setItem('target','1')
          this.getLeftBuildingMap('1');
          break;
        case "/content/BasicData": //基础数据管理-监测点管理
          sessionStorage.setItem("router", "BasicData"); // 判断顶部进入那个路由
          sessionStorage.setItem("navAddShow", false);
          this.$store.state.navAddShow = false;
          this.$store.state.listenerIsWarn=false;

          this.$store.state.routerUrl=false;
          this.$store.state.routerUrlName=key;
          this.$store.state.menuS = sessionStorage.getItem("buildingId")
          sessionStorage.setItem('showcus','0')  // 客户是否可以点击1表示可以0不可以
          sessionStorage.setItem('target','1')
          this.getLeftBuilding('1');
          break;
        case "/content/constructionManagement": //基础数据管理-建筑管理
          sessionStorage.setItem("navAddShow", true);
          this.$store.state.navAddShow = true;
          this.$store.state.listenerIsWarn=false;
          this.$store.state.routerUrl=false;
          this.$store.state.routerUrlName=key;
          sessionStorage.setItem("router", "constructionManagement"); // 判断顶部进入那个路由
          sessionStorage.setItem('showcus','1')  // 客户是否可以点击1表示可以0不可以
          sessionStorage.setItem('target','1')
          sessionStorage.setItem('floor','0');

          if(sessionStorage.getItem('userType')!=0){ // 校企端
            sessionStorage.setItem('menuS',sessionStorage.getItem("customerId"));
            this.$store.state.menuS = sessionStorage.getItem("customerId");
            this.getBuilding('1');
          }else{ // 监管端
            sessionStorage.setItem('menuS',JSON.parse(sessionStorage.getItem("leftData"))[0].children[0].id);
            this.$store.state.menuS = JSON.parse(sessionStorage.getItem("leftData"))[0].children[0].id;
            this.getBuilding('1');
          }

            let from = {
                buildingName: '',
                area: '',
                address: [],
                onFloor: '',
                underFloor: '',
                coverArea: '',
                detailAddress: '',
            }
            sessionStorage.setItem('editBulitData',JSON.stringify(from));
            this.$store.state.editBulitData = from;
            sessionStorage.setItem('saveBtn',true);
            this.$store.state.saveBtn = true;
          break;
        // case "/roleManger": //角色管理
        //   sessionStorage.setItem("navAddShow", false);
        //   this.$store.state.navAddShow = false;
        //   this.$store.state.listenerIsWarn=false;
        //   this.$store.state.routerUrlName=key;
        //   this.$store.state.routerUrl=false;
        //   break;
        // case "/userManger": //用户管理
        //   sessionStorage.setItem("navAddShow", false);
        //   this.$store.state.navAddShow = false;
        //   this.$store.state.listenerIsWarn=false;
        //   this.$store.state.routerUrlName=key;
        //   this.$store.state.routerUrl=false;
        //   break;
        // case "/permissions": //权限管理
        //   sessionStorage.setItem("navAddShow", false);
        //   this.$store.state.navAddShow = false;
        //   this.$store.state.routerUrlName=key;
        //   this.$store.state.listenerIsWarn=false;
        //   this.$store.state.routerUrl=false;
        //   break;
        // case "/parameterManger": //参数管理
        //   sessionStorage.setItem("navAddShow", false);
        //   this.$store.state.navAddShow = false;
        //   this.$store.state.routerUrlName=key;
        //   this.$store.state.listenerIsWarn=false;
        //   this.$store.state.routerUrl=false;
        //   break;
        // case "/journal": //日志管理
        //   sessionStorage.setItem("navAddShow", false);
        //   this.$store.state.navAddShow = false;
        //   this.$store.state.routerUrlName=key;
        //   this.$store.state.listenerIsWarn=false;
        //   this.$store.state.routerUrl=false;
        //   break;
        default:
      }
    },
    editUserInfo() {
      sessionStorage.setItem('showListPage',true)
      this.$router.push({path:'/userInfo',query:{showListPage:true,msg:'head'}})
    },
    getBuilding(a) {
      if(this.isAuth('common:interface')) {
           let params = {
            buildingName: "",
            target: a,
             customerId:sessionStorage.getItem('customerId1'), //6期教育局2020.8.19
          };
        if(sessionStorage.getItem('userType') == '0'){ //如果集团进入target置空
             params.target =''
             params.customerId =sessionStorage.getItem('bureaucustomerId')
       }
          ajaxFuncJson("/basicData/getBuilding", params).then(res => {
            if (res.data.status == 200) { // 查询建筑列表

              if(this.userType != 0){
                sessionStorage.setItem("leftData", JSON.stringify(res.data.data));
                sessionStorage.setItem("customerId", res.data.data[0].id);
                sessionStorage.setItem("differentiate", true);
                sessionStorage.setItem("rightList", false);
                this.$store.state.rightList = false
                sessionStorage.setItem("btnShow", true);
                this.$store.dispatch("getLeftDataList", res.data.data);
                sessionStorage.setItem('Name', res.data.data[0].label)
              }else{
                sessionStorage.setItem("leftData", JSON.stringify(res.data.data));
                sessionStorage.setItem("customerId", res.data.data[0].children[0].id);
                sessionStorage.setItem("differentiate", true);
                sessionStorage.setItem("rightList", false);
                this.$store.state.rightList = false
                sessionStorage.setItem("btnShow", true);
                this.$store.dispatch("getLeftDataList", res.data.data);
                sessionStorage.setItem('Name', res.data.data[0].label)
              }
            }
          });
      }
    },
    getLeftBuilding(a) { 
      let params = {
          buildingName: '',
           customerId:sessionStorage.getItem('customerId1'), //6期教育局2020.8.19
          target: a,
      }
      if(sessionStorage.getItem('userType') == '0'){ //如果集团进入target置空
             params.target =''
             params.customerId =sessionStorage.getItem('bureaucustomerId')
       }
      ajaxFuncJson('/basicData/getBuilding',params).then(res=>{
        if(res.data.status==200&&res.data.data.length>0) {
          //当时统计页面
           if(sessionStorage.getItem('router')!='analysis'||sessionStorage.getItem('router')!='MonitoringSupervise'){
            let goHref = 1;
            if(sessionStorage.getItem('userType')!=0){
              res.data.data.forEach((item,index)=>{
                item.children.forEach((item1,index1)=>{
                  if(item1.id==sessionStorage.getItem("menuS")){
                    sessionStorage.setItem("leftData", JSON.stringify(res.data.data));
                    this.$store.dispatch("getLeftDataList", res.data.data);
                    goHref = 2;
                  }
                })
              })
            }
            if(goHref==2)return;
            // 查询建筑列表
              for(var item in res.data.data) {
                  for(var ite in res.data.data[item].children) {
                      if(res.data.data[item].children[ite].isShowRed==1){
                          res.data.data[item].showRed = true;     
                      }
                  }
              }
              sessionStorage.setItem('leftData',JSON.stringify(res.data.data));
              sessionStorage.setItem('remark','0');
              sessionStorage.setItem('customerId',res.data.data[0].id); // 默认缓存第一个客户id

              if(sessionStorage.getItem('userType')!=0){
                if (res.data.data[0].children != 0) {
                    this.$store.state.buildingId = res.data.data[0].children[0].id;
                    sessionStorage.setItem('menuS',res.data.data[0].children[0].id); // 默认选中第一个建筑id
                    sessionStorage.setItem('Name', res.data.data[0].children[0].label); // 默认缓存第一个客户名
                    sessionStorage.setItem('buildingId',res.data.data[0].children[0].id); //默认缓存第一个客户
                    sessionStorage.setItem('activeIndex',res.data.data[0].children[0].id);
                    this.$store.state.menuS = res.data.data[0].children[0].id;
                }else{
                    sessionStorage.setItem('menuS',''); // 默认选中第一个建筑id
                    sessionStorage.setItem('Name', ''); // 默认缓存第一个客户名
                    sessionStorage.setItem('buildingId',''); //默认缓存第一个客户
                    this.$store.state.menuS = '';
                }
              }else{
                if(res.data.data[0].children.length>0){
                  this.arrayObject = [];
                  if(sessionStorage.getItem('router')!='warningManger'||sessionStorage.getItem('router')!='indexExamine'||sessionStorage.getItem('router')!='searchWarnIndex'){
                      sessionStorage.setItem('customerId',res.data.data[0].children[0].id); 
                  }
                  try{ 
                    
                    res.data.data[0].children.forEach((item,index)=>{
                      if(item.children.length>0){
                        this.arrayObject.push(item.children[0].id)
                        this.$store.state.buildingId = item.children[0].id;
                        sessionStorage.setItem('menuS',item.children[0].id); // 默认选中第一个建筑id
                        sessionStorage.setItem('Name', item.children[0].label); // 默认缓存第一个客户名
                        sessionStorage.setItem('buildingId',item.children[0].id); //默认缓存第一个客户
                        sessionStorage.setItem('activeIndex',item.children[0].id);
                        this.$store.state.menuS = item.children[0].id;
                        throw new Error("EndIterative");
                      }
                        
                    })
                  }catch(e){ 
                    if(e.message!="EndIterative") throw e;

                  }//可以跳出来

                }
              }
              sessionStorage.setItem('showcus','0')  // 客户是否可以点击1表示可以0不可以
              sessionStorage.setItem('differentiate',true);
              sessionStorage.setItem('rightList',false)
              sessionStorage.setItem('btnShow',true)
              sessionStorage.setItem('navAddShow',false);
              this.$store.state.navAddShow = false;
              this.$store.dispatch('getLeftDataList',res.data.data)
              if(sessionStorage.getItem('remark') == '0'){
                this.getpointMap(sessionStorage.getItem('customerId'));
              }
          }else{
            sessionStorage.setItem("leftData", JSON.stringify(res.data.data));
            this.$store.dispatch("getLeftDataList", res.data.data);
          }

        }
      })
    },
    getLeftBuildingMap(a) { //校企标注左侧导航

      let params = {
          customerId:sessionStorage.getItem('customerId1'), //6期教育局2020.8.19
          buildingName: '',
          target: a,
      }
       if(sessionStorage.getItem('userType') == '0'){ //如果集团进入target置空
             params.target =''
             params.customerId =sessionStorage.getItem('bureaucustomerId')
       }
      ajaxFuncJson('/basicData/getCustomerList',params).then(res=>{
        if(res.data.data[0].active){
          res.data.data[0].active = false; //12-26X
        }

        sessionStorage.setItem("leftData", JSON.stringify(res.data.data));
        this.$store.dispatch("getLeftDataList", res.data.data);
        if(sessionStorage.getItem('router')=='MonitoringSupervise'){
           sessionStorage.setItem('buildingId',res.data.data[0].children[0].id);  //默认缓存第一个客户2020.9.24
          //  sessionStorage.setItem('menuS',res.data.data[0].children[0].id);  //默认缓存第一个客户2020.9.24
           this.getAlarmList();
        }
      })
    },
     //监管端报警小红点
    getAlarmList() { 
      let params = {
          pageType: 0,
          customerId:sessionStorage.getItem('customerId1'), //6期教育局2020.8.19
      }
      ajaxFuncJson('/basicData/getAList',params).then(res=>{
        if(res.data.status == 200){
          let InfoArr = JSON.parse(sessionStorage.getItem('leftData'))
          if(this.userType!=0){
                    InfoArr.forEach((item,index)=>{
                      if(res.data.data.length>0){
                        item.alarmTrue = 1;
                        item.children.forEach((item1,index)=>{
                          res.data.data.forEach((item2,index)=>{
                            if(item1.id == item2){
                                item1.alarmTrue = 1;
                            }
                          })
                          
                        })
                      }
                    })
                  }else{
                    InfoArr.forEach((item,index)=>{
                      if(res.data.data.length>0){
                        item.alarmTrue = 1;
                        item.children.forEach((item1,index)=>{

                          item1.children.forEach((item2,index2)=>{  


                              res.data.data.forEach((item3,index3)=>{
                                if(item2.id == item3){
                                      item1.alarmTrue = 1;
                                    item2.alarmTrue = 1;
                                }
                              })


                          })

                          
                          
                        })
                      }
                    })

                  }




          sessionStorage.setItem("leftData", JSON.stringify(InfoArr));
          this.$store.dispatch("getLeftDataList", InfoArr);
        }
      })
    },
    getpointMap(customerId) { //四期总览图建筑点请求
      if (this.isAuth('common:interface') && sessionStorage.getItem('remark') == '0') {
        // let params = {
        //   id: customerId
        // };
        // ajaxFuncJson("/building/showBuilding", params).then(res => {
        //   sessionStorage.setItem("pointData", JSON.stringify(res.data.data));
        //   this.$store.dispatch("getRightPoint", res.data.data);
        // });
      }
    },
    Bigscreen(){ //大屏
         if(sessionStorage.getItem("userType") == 0){// 集团
            sessionStorage.setItem('customerId',sessionStorage.getItem("bureaucustomerId"))
            sessionStorage.setItem('customerId1',sessionStorage.getItem("bureaucustomerId"))
           sessionStorage.setItem('customerId','')//清空集团id2020.9.30
           sessionStorage.setItem('buildingId','')//清空集团id2020.9.30
           this.$store.state.bigScreenBuildingId='';
          }
          this.$store.state.menuS = '';
          sessionStorage.setItem('menuS','')
      console.log(this.socketMonitorMsgAlarm+'已经关闭')
      this.socketMonitorMsgAlarm.close();
                  this.$router.push({
                          path:'/mapIndex',
                          query:{
                          id:123
                      }
                    });
    },
    logout() {  // 退出登录
        ajaxFuncJsonLogin("/auth_user/logout", '').then(res => {
            if(res.data.status == 200) {
                this.$router.push({ path: "/" });
                sessionStorage.clear();
                location.reload(true)
            }
        });
    }
  }
};
</script>
<style scoped lang="scss">
  @import "@/assets/css/mixin.scss";
  .popoverContent {
    box-shadow: 0 2px 4px rgba(0,0,0,.1);
  }
.povperMsg {
  height: 73px;
  border-bottom: 1px solid #e0e0e0;
  .left{
    float: left;
    margin-top: 10px;
  }
  .right {
    float: right;
    margin-top: 10px;
    right: 0px;
  }
  .left {
    width: 244px;
    padding-right: 20px;
    .msg {
      position: relative;
      // width: 224px;
      width: 236px;
      height: 36px;
      font-size: 13px !important;
      overflow: hidden !important;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      color: #282828 !important;
      color: #282828 !important;
      &:after {
          content: "...";
          position: absolute;
          bottom: -4px;
          right: 0;
          width: 20px;
          height:22px;
          color:#999;
          background-color:#fff;
      }
    }
    .msg1{
      position: relative;
      width: 225px;
      height: 36px;
      font-size: 13px !important;
      overflow: hidden !important;
      color: #282828 !important;
    }
    .time {
      font-size: 12px;
      color: #999999;
      bottom: 12px;
    }
  }
  .right {
    .know {
      margin-bottom: 5px;
    }
  }
}
// 顶部导航
.logoNav {
  width: 19.8%;
  min-width: 270px;
  max-width: 380px;
  @include flexible;
  @include alignItems(center);
  padding-left: 0.4rem;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -ms-box-sizing: border-box;
  & > div:first-child {
    width: 28px;
    height: 28px;
    margin-right: 0.15rem;
  }
}
.Navigation {
  width: 80.2%;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  @include flexible;
  @include alignItems(center);
  @include justify(space-between);
  .listNavigation {
    @include flexible;
    @include alignItems(center);
    & > ul {
      display: block;
      border-bottom: 1px solid #fff;
    }
  }
  .el-menu--horizontal {
    height: 100%;
    font-size: $fontSizeThree;
    cursor: pointer;
    border-bottom: 1px solid #fff;
    & > div {
      @include flexible;
      @include alignItems(center);
      @include justify(center);
      flex: 0 0 110px;
      height: 100%;
      padding-right: 0.1rem;
      &:hover {
        color: #198cff;
      }
    }
  }
  .userNavigation {
    @include flexible;
    @include alignItems(center);
    cursor: pointer;
    & > div {
      // margin-right: 0.2rem;
      &:first-child {
        @include flexible;
        @include alignItems(center);
        width: 28px;
        height: 28px;
        text-align: center;
        &>.isDot:hover {
          color: #198cff;
        }
      }
      &:nth-child(2) {
        padding-right: 0.1rem;
        & > img {
          width: 38px;
          height: 38px;
          vertical-align: middle;
          @include borderRadius(50%);
        }
      }
      &:nth-child(3) {
        width: 96px;
        height: 24px;
        line-height: 24px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        &:hover {
          color: #198cff;
        }
      }
      &:last-child {
        width: 28px;
        height: 28px;
        line-height: 28px;
        margin-right:20px;
        &:hover {
          color: #198cff;
        }
      }
    }
  }
}
.el-menu--popup-bottom-start a {
  height: 30px;
  line-height: 30px;
}
.popoverContent {
  position: fixed;
  width: 360px;
  top: 50px;
  right: 26px;
  background: #fff;
  z-index: 66;
  .popoverContent__arrow em{
    display:block;
    border-width:6px;
    position:absolute;
    top: -12px;
    left:146px;
    border-style:solid dashed dashed; 
    border-color:transparent transparent #fff transparent;
    font-size:0;
    line-height:0;
  }
  .know .el-button {
    width: 80px !important;
    min-width: 80px !important;
    height: 24px !important;
    padding: 0 !important;
  }
  .check .el-button {
    width: 80px !important;
    min-width: 80px !important;
    height: 24px !important;
    padding: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TopNav.vue